// lib
import React from 'react'
import PropTypes from 'prop-types'
import ManagedRenderComponent from '@aytm/lib/common/components/ManagedRenderComponent'

// components
import ImagePopup from '@aytm//lib/rfd-ui/components/basic/image-popup'
import Popup, { PopupContent } from '@aytm/lib/rfd-ui/components/basic/popup'

// style
import style from '@aytm/app/survey/editor/styles/content/assets/ImagePreview.module.scss'

// <Components>
export default class ImagePreview extends ManagedRenderComponent {
  static propTypes = {
    label: PropTypes.string,
    altText: PropTypes.string,
    imageUrl: PropTypes.string,
    previewUrl: PropTypes.string,
    maxHeight: PropTypes.string,
    maxWidth: PropTypes.string,
    minWidth: PropTypes.string,
    minHeight: PropTypes.string,
    hideInlineZoom: PropTypes.bool,
    doubleBuffering: PropTypes.bool,
    allowScrolling: PropTypes.bool,
    onPreviewLoaded: PropTypes.func,
    onImageOpen: PropTypes.func,
    onImageHide: PropTypes.func,
    onImageLoaded: PropTypes.func
  }
  static updateOnProps(nextProps, prevProps) {
    return (
      nextProps.imageUrl != prevProps.imageUrl ||
      nextProps.previewUrl != prevProps.previewUrl ||
      nextProps.maxHeight != prevProps.maxHeight ||
      nextProps.maxWidth != prevProps.maxWidth ||
      nextProps.minWidth != prevProps.minWidth ||
      nextProps.minHeight != prevProps.minHeight ||
      nextProps.hideInlineZoom != prevProps.hideInlineZoom ||
      nextProps.doubleBuffering != prevProps.doubleBuffering ||
      nextProps.onImageLoaded != prevProps.onImageLoaded
    )
  }

  static contextTypes = {
    popup: PropTypes.instanceOf(Popup),
    popupContent: PropTypes.instanceOf(PopupContent)
  }

  state = {
    loading: true,
    loaded: false,
    previewUrl: null,
    previewState: 'fetch',
    showImage: false
  }

  constructor(props, context) {
    super(props, context)
    this.setPreviewImage = this.setPreviewImage.bind(this)
    this.reposition = this.reposition.bind(this)
    this.onLoaded = this.onLoaded.bind(this)
    this.showImage = this.showImage.bind(this)
    this.hideImage = this.hideImage.bind(this)
    this.previewImage = null
  }

  componentDidMount() {
    const { previewUrl } = this.props
    this.setPreviewImage(previewUrl)
  }

  componentDidUpdate(prevProps, _prevState, _snapshot) {
    const { previewUrl } = this.props
    if (prevProps.previewUrl != previewUrl) {
      this.setPreviewImage(previewUrl)
    }
  }

  setPreviewImage(url) {
    if (false === this.props.doubleBuffering) {
      this.setState({ previewState: 'fetched', previewUrl: url }, () => {
        this.reposition()
      })
    } else {
      this.previewImage = document.createElement('img')
      this.previewImage.addEventListener('load', () => {
        const { onPreviewLoaded } = this.props
        if ('function' == typeof onPreviewLoaded) {
          onPreviewLoaded(url)
        }
        this.setState({ previewState: 'fetched', previewUrl: url }, () => {
          this.reposition()
        })
      })
      this.setState({ previewState: 'fetch' }, this.reposition)
      setTimeout(() => {
        if (this.mounted && 'fetch' == this.state.previewState) {
          this.setState({ previewState: 'fetching' }, this.reposition)
        }
      }, 200)
      this.previewImage.src = url
    }
  }

  reposition() {
    const { popupContent } = this.context
    if (popupContent) {
      setTimeout(() => {
        popupContent.reposition()
      }, 0)
      setTimeout(() => {
        // control shot!
        popupContent.reposition()
      }, 100)
    }
  }

  onLoaded() {
    const { onImageLoaded } = this.props
    setTimeout(() => {
      this.reposition()
      if ('function' == typeof onImageLoaded) {
        onImageLoaded()
      }
    }, 10)
    this.setState({ loading: false, loaded: true })
  }

  showImage() {
    const { popup } = this.context
    const { onImageOpen } = this.props
    if (popup) popup.freeze()
    if ('function' == typeof onImageOpen) onImageOpen()
    this.setState({
      showImage: true
    })
  }

  hideImage() {
    const { popup } = this.context
    const { onImageHide } = this.props
    if (popup) {
      popup.unfreeze()
      popup.hide()
    }
    if ('function' == typeof onImageHide) onImageHide()
    this.setState({
      showImage: false
    })
  }

  render() {
    const { label, altText, imageUrl, maxHeight, maxWidth, minHeight, minWidth, allowScrolling, hideInlineZoom } =
      this.props
    const { loading, loaded, previewUrl, previewState, showImage } = this.state
    return (
      <div
        className={`${style.component}${'fetched' != previewState ? ' ' + style.loading : ''}`}
        style={{ maxHeight, maxWidth, minWidth, minHeight }}
      >
        {previewUrl && (
          <div
            className={`${style.image}${loading ? ' ' + style['image-loading'] : ''}${
              loaded ? ' ' + style['image-loaded'] : ''
            }${hideInlineZoom ? ' ' + style['image-inactive'] : ''}`}
            onClick={hideInlineZoom ? null : this.showImage}
            style={{ minWidth }}
          >
            <div className={style.imageHolder} style={{ maxHeight, minWidth, maxWidth }}>
              <img alt={altText} src={previewUrl} onLoad={this.onLoaded} style={{ maxHeight, maxWidth }} />
              {loading && !loaded && (
                <div className={style.loader}>
                  <i className="icon-aytmfd-spin aytmfd-spin" />
                </div>
              )}
              {'fetched' == previewState && !hideInlineZoom && <i className={style.zoom} onClick={this.showImage} />}
            </div>
          </div>
        )}
        {'fetching' == previewState && <i className={style['loading-icon']} />}
        <ImagePopup
          label={label}
          altText={altText}
          src={imageUrl}
          show={showImage}
          scrolling={allowScrolling}
          onClose={this.hideImage}
          closeOnClick={true}
        />
      </div>
    )
  }
}
